import React from 'react';
import PropTypes from 'prop-types';
import glamorous from 'glamorous';
import {PHONE} from '../../../style/breakpoints';
import {ASH, WHITE, GUNSMOKE} from '../../../style/colors';
import {BASE_TEXT, WEIGHT} from '../../../style/typography';
import {ALPHA} from '../../../style/color-utils';
import {skipForceVcsConnection} from '../../../../data/shared/mutations';
import {user} from '../../../../data/shared/queries';
import {FORCED_VCS_PROVIDERS} from './constants/constants';

const Container = glamorous.div({
  height: 116,
  display: 'flex',
  background: WHITE,
  border: `1px solid ${ASH}`,
  position: 'relative',
  borderRadius: 4,
  margin: '0 0 22px 0',
  padding: 28,
  alignItems: 'center',
  justifyContent: 'space-between',
  zIndex: 1,
  [PHONE]: {
    flexDirection: 'column',
    justifyContent: 'center',
    height: 200,
    padding: '5px 10px',
    margin: 10
  },
  ':hover > svg': {
    '> g': {
      fill: GUNSMOKE,
      stroke: GUNSMOKE
    }
  }
});

const Heading = glamorous.p({
  ...BASE_TEXT,
  fontSize: 14,
  fontWeight: WEIGHT.BOLD,
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: 1.5,
  color: '#3a3a3a',
  marginBottom: 5,
  [PHONE]: {
    margin: 0,
    fontSize: '10px'
  }
});

const Title = glamorous.p({
  ...BASE_TEXT,
  fontSize: 13,
  fontWeight: WEIGHT.NORMAL,
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: 1.43,
  color: '#828282',
  [PHONE]: {
    margin: '2px 0 5px',
    fontSize: '10px'
  }
});

const IconWithText = glamorous.div({
  display: 'flex',
  alignItems: 'center',
  background: WHITE,
  [PHONE]: {
    flexDirection: 'column',
    alignItems: 'center'
  }
});

const SubText = glamorous.div({
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  marginLeft: 19
});

const Button = glamorous.a(({customStyle, customStyleHover}) => ({
  ...BASE_TEXT,
  minWidth: 152,
  height: 40,
  letterSpacing: 'normal',
  lineHeight: '40px',
  color: '#fff',
  textAlign: 'center',
  ...customStyle,
  '&:hover': {
    ...customStyleHover
  },
  [PHONE]: {
    height: 40,
    width: 70,
    padding: 0,
    fontSize: 11
  }
}));

const SkipText = glamorous.p({
  ...BASE_TEXT,
  fontWeight: WEIGHT.NORMAL,
  width: 'max-content',
  marginTop: 9,
  [PHONE]: {
    margin: '10px auto 0 auto'
  },
  fontSize: 11,
  textAlign: 'center',
  color: '#828282',
  '&:hover': {
    cursor: 'pointer'
  }
});

const CtaContainer = glamorous.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  [PHONE]: {
    marginTop: 5
  }
});

const SsoGithubCtaBanner = ({client, forcedVcsProvider}) => {
  const skipVcsConnection = async () => {
    try {
      await client.mutate({
        mutation: skipForceVcsConnection,
        refetchQueries: [{query: user}],
        awaitRefetchQueries: true
      });
    } catch (error) {
      /* eslint-disable no-console */
      console.error(error);
      alert(
        'There was a problem processing your request. Please try again and if the problem persists please email us at contact@stackshare.io.'
      );
    }
  };
  return (
    forcedVcsProvider && (
      <Container>
        <IconWithText>
          {FORCED_VCS_PROVIDERS[forcedVcsProvider].icon}
          <SubText>
            <Heading>
              Please connect your user profile to your{' '}
              {FORCED_VCS_PROVIDERS[forcedVcsProvider].name} account
            </Heading>
            <Title>
              {`According to your company's policies, you need to connect your user profile to your ${
                FORCED_VCS_PROVIDERS[forcedVcsProvider].name
              }
        account to access this page`}
            </Title>
          </SubText>
        </IconWithText>
        <CtaContainer>
          <Button
            href={`/users/auth/${FORCED_VCS_PROVIDERS[forcedVcsProvider].slug}`}
            customStyle={{
              background: FORCED_VCS_PROVIDERS[forcedVcsProvider].backgroundColor,
              borderColor: FORCED_VCS_PROVIDERS[forcedVcsProvider].borderColor
            }}
            customStyleHover={{
              backgroundColor: ALPHA(FORCED_VCS_PROVIDERS[forcedVcsProvider].backgroundColor, 0.8),
              borderColor: ALPHA(FORCED_VCS_PROVIDERS[forcedVcsProvider].borderColor, 0.79),
              color: WHITE
            }}
          >
            Connect to {FORCED_VCS_PROVIDERS[forcedVcsProvider].name}
          </Button>
          <SkipText onClick={() => skipVcsConnection()}>
            I don’t have a {FORCED_VCS_PROVIDERS[forcedVcsProvider].name} account
          </SkipText>
        </CtaContainer>
      </Container>
    )
  );
};

SsoGithubCtaBanner.propTypes = {
  client: PropTypes.object,
  forcedVcsProvider: PropTypes.string
};

export default SsoGithubCtaBanner;
